module.exports = __webpack_public_path__ + "components/flag/static/square/bd-7c04d50b0222dfc01a6a8d38784c3f28.svg";